import { type ComponentProps, useMemo } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Button, { TooltipButton } from "@/v2-backoffice-client/components/button"
import { useTableContext } from "./table.context"
import type { ColumnFilterConfig } from "./table.types"
import TableFilterRow from "./filter/TableFilterRow"
import TableFilterPanelTabs from "./filter/TableFilterPanelTabs"

export type TableToolbarFilterPanelProps = ComponentProps<"div"> & {
  onClose(): void
}

function TableToolbarFilterPanel(props: TableToolbarFilterPanelProps) {
  const { onClose, className, ...divProps } = props
  const { table } = useTableContext()

  const filterableColumns = useMemo(() => {
    return table.getAllColumns().filter((column) => {
      if (column.id === "__select") return false
      const meta = column.columnDef.meta as
        | { filter?: ColumnFilterConfig }
        | undefined
      return !!meta?.filter && !meta.filter.toolbar
    })
  }, [table])

  const { columnFilters } = table.getState()
  const activeFilterCount = columnFilters.length

  return (
    <div className={cn("ui-table-toolbar-panel", className)} {...divProps}>
      <div className="ui-table-toolbar-panel-header">
        <TableFilterPanelTabs />
        {activeFilterCount > 0 && (
          <Button
            variant="ghost"
            size="xs"
            onClick={() => table.resetColumnFilters()}
          >
            Clear all
          </Button>
        )}
        <div className="ui-table-toolbar-panel-header-spacer" />
        <TooltipButton
          variant="ghost"
          size="xs"
          iconSrc="cross-small"
          iconClassName="ui-table-panel-close-icon"
          label="Close the filter panel"
          onClick={onClose}
        />
      </div>

      <div className="ui-table-toolbar-panel-body">
        {filterableColumns.map((column) => (
          <TableFilterRow key={column.id} column={column} />
        ))}
      </div>
    </div>
  )
}

export default TableToolbarFilterPanel
